import React from "react";

const Experience = ({ theme }) => {
  const experience = [
    {
      id: 1,
      company: "Sigmoid",
      position: "Software Engineer - 2",
      start: "July 2023",
      end: "Present",
      imgUrl:
        "https://media.licdn.com/dms/image/v2/C510BAQHCjinIyrml3g/company-logo_100_100/company-logo_100_100/0/1630608391617/sigmoid_analytics_logo?e=1743033600&v=beta&t=pvhzkakaROl6QuGboTcyuBvyFzFvUl_uxL__SlLtLi8",
    },
    {
      id: 2,
      company: "Sudoviz",
      position: "Frontend Developer",
      start: "Jan 2023",
      end: "July 2023",
      imgUrl:
        "https://media.licdn.com/dms/image/v2/C560BAQEoa2BgcA9XMQ/company-logo_100_100/company-logo_100_100/0/1630637586154?e=1743033600&v=beta&t=OKbYG9bQ_h2jQB2o4C50KDhu0oe1NV1NnorU2wNO6Lw",
    },
    {
      id: 3,
      company: "Yellomonkey Labs",
      position: "Software Engineer",
      start: "Nov 2021",
      end: "Dec 2022",
      imgUrl:
        "https://media.licdn.com/dms/image/v2/C4D0BAQFXjXad_KEwpQ/company-logo_100_100/company-logo_100_100/0/1649420009229/yellomonkey_labs_logo?e=1743033600&v=beta&t=J_sV3KEkyVV4NfiI4KYgfFeyYFsHLdvav_-mvCeLh9Y",
    },
  ];

  return (
    <div className="card shadow-lg compact bg-base-100">
      <div className="card-body">
        <div className="mx-3">
          <h5 className="card-title">
            <span className="text-base-content opacity-70">Experience</span>
          </h5>
        </div>
        <div className="text-base-content text-opacity-60">
          <ol className="overflow-hidden space-y-8">
            {experience.map((item) => (
              <li
                key={item.id}
                className={`relative flex-1 after:content-[''] after:w-0.5 after:h-full ${
                  theme === "dark" ? "after:bg-gray-700" : "after:bg-gray-200"
                } after:inline-block after:absolute after:-bottom-11 after:left-[8%]`}
              >
                <div className="flex items-center justify-center gap-8 w-full max-w-sm">
                  <div
                    className={`flex items-center gap-3.5 p-3.5 rounded-xl relative z-10 border w-full ${
                      theme === "dark"
                        ? "bg-[#15191e] text-white border-[#15191e]"
                        : "bg-[#eff0f0] text-black border-gray-50"
                    }`}
                  >
                    <div
                      className={`rounded-lg flex items-center justify-center ${
                        theme === "dark" ? "bg-gray-600" : "bg-gray-200"
                      }`}
                    >
                      <span
                        className={`p-2 ${
                          theme === "dark" ? "text-gray-400" : "text-gray-600"
                        }`}
                      >
                        {/* <img
                          src={item.imgUrl}
                          alt="company logo"
                          className="w-8 h-8 rounded-lg"
                        /> */}
                        <svg
                          class="octicon octicon-organization"
                          viewBox="0 0 16 16"
                          version="1.1"
                          width="16"
                          height="16"
                          aria-hidden="true"
                          fill={theme === "dark" ? "white" : "black"}
                        >
                          <path d="M1.75 16A1.75 1.75 0 0 1 0 14.25V1.75C0 .784.784 0 1.75 0h8.5C11.216 0 12 .784 12 1.75v12.5c0 .085-.006.168-.018.25h2.268a.25.25 0 0 0 .25-.25V8.285a.25.25 0 0 0-.111-.208l-1.055-.703a.749.749 0 1 1 .832-1.248l1.055.703c.487.325.779.871.779 1.456v5.965A1.75 1.75 0 0 1 14.25 16h-3.5a.766.766 0 0 1-.197-.026c-.099.017-.2.026-.303.026h-3a.75.75 0 0 1-.75-.75V14h-1v1.25a.75.75 0 0 1-.75.75Zm-.25-1.75c0 .138.112.25.25.25H4v-1.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v1.25h2.25a.25.25 0 0 0 .25-.25V1.75a.25.25 0 0 0-.25-.25h-8.5a.25.25 0 0 0-.25.25ZM3.75 6h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM3 3.75A.75.75 0 0 1 3.75 3h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 3.75Zm4 3A.75.75 0 0 1 7.75 6h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 7 6.75ZM7.75 3h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5ZM3 9.75A.75.75 0 0 1 3.75 9h.5a.75.75 0 0 1 0 1.5h-.5A.75.75 0 0 1 3 9.75ZM7.75 9h.5a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5Z"></path>
                        </svg>
                      </span>
                    </div>
                    <div className="flex items-start rounded-md justify-center flex-col">
                      <h6
                        className={`text-base font-semibold mb-0.5 ${
                          theme === "dark" ? "text-white" : "text-black"
                        }`}
                      >
                        {item.position}
                      </h6>
                      <p
                        className={`text-xs font-normal ${
                          theme === "dark" ? "text-gray-400" : "text-gray-500"
                        }`}
                      >
                        {item.company}
                      </p>
                      <p
                        className={`text-xs font-normal mt-1 ${
                          theme === "dark" ? "text-gray-400" : "text-gray-500"
                        }`}
                      >
                        {item.start} - {item.end}
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Experience;
